module.exports = require("@pb/kit-component-button");